import { render } from "./MainWithoutFooterLayout.vue?vue&type=template&id=6d0ffd8e&scoped=true"
import script from "./MainWithoutFooterLayout.vue?vue&type=script&lang=js"
export * from "./MainWithoutFooterLayout.vue?vue&type=script&lang=js"

import "./MainWithoutFooterLayout.vue?vue&type=style&index=0&id=6d0ffd8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0ffd8e"]])

export default __exports__